import { useState } from 'react'
import './App.css'

function App() {
  const [menuOpen, setMenuOpen] = useState(false)

  return (
    <div className="app">
      {/* NAVBAR */}
      <nav className="navbar">
        <div className="navbar-container">
          <a href="#inicio" className="navbar-brand">
            <img src="/images/logo_marx_flow.png" alt="MarxFlow Logo" className="navbar-logo" />
            <div className="navbar-brand-text">
              <span className="navbar-title">MarxFlow</span>
              <span className="navbar-slogan">O fluxo do capital sob controle</span>
            </div>
          </a>
          <ul className={`navbar-links ${menuOpen ? 'active' : ''}`}>
            <li><a href="#inicio" onClick={() => setMenuOpen(false)}>Início</a></li>
            <li><a href="#manifesto" onClick={() => setMenuOpen(false)}>Manifesto</a></li>
            <li><a href="#funcionalidades" onClick={() => setMenuOpen(false)}>Funcionalidades</a></li>
            <li><a href="#camarada" onClick={() => setMenuOpen(false)}>O Camarada</a></li>
            <li><a href="#como-funciona" onClick={() => setMenuOpen(false)}>Como Funciona</a></li>
            <li><a href="https://app.marxflow.com.br/auth" target="_blank" rel="noopener noreferrer" className="navbar-cta">Login</a></li>
          </ul>
          <button className="navbar-toggle" onClick={() => setMenuOpen(!menuOpen)} aria-label="Menu">
            {menuOpen ? '✕' : '☰'}
          </button>
        </div>
      </nav>

      {/* HERO */}
      <section className="hero" id="inicio">
        <div className="hero-container">
          <div className="hero-text">
            <div className="hero-badge">✊ 100% gratuito para o povo</div>
            <h1>
              O controle financeiro nas <span>mãos do trabalhador</span>
            </h1>
            <p className="hero-tagline">O fluxo do capital sob controle.</p>
            <p className="hero-description">
              Chega de enriquecer bancos e fintechs com seus dados. O MarxFlow é o aplicativo
              gratuito que devolve ao povo o poder de controlar suas finanças — sem taxas,
              sem exploração, sem letras miúdas.
            </p>
            <div className="hero-buttons">
              <a href="#cadastrar" className="btn-primary-hero">
                Cadastrar Agora — É Grátis
              </a>
              <a href="#funcionalidades" className="btn-secondary-hero">
                Conhecer Funcionalidades →
              </a>
            </div>
            <div className="hero-stats">
              <div className="hero-stat">
                <h3>5+</h3>
                <p>Camaradas usando</p>
              </div>
              <div className="hero-stat">
                <h3>R$ 0</h3>
                <p>Preço justo, sempre</p>
              </div>
              <div className="hero-stat">
                <h3>4.9 ★</h3>
                <p>Nota nas lojas</p>
              </div>
            </div>
          </div>

          <div className="hero-visual">
            <div className="hero-mockup">
              <div className="floating-element el-1">
                <span className="fe-icon">📈</span>
                <span className="fe-label">Receitas</span>
                <div className="fe-value">+R$ 5.000</div>
              </div>
              <div className="floating-element el-2">
                <span className="fe-icon">🛡️</span>
                <span className="fe-label">Segurança</span>
                <div className="fe-value" style={{color: '#28A745'}}>100%</div>
              </div>
              <div className="mockup-card">
                <div className="mockup-header">
                  <div className="mockup-avatar">
                    <img src="/images/camarada/marxflow_moeda.png" alt="Avatar do usuário" className="mockup-avatar-image" />
                  </div>
                  <div>
                    <div className="mockup-greeting">Boa noite,</div>
                    <div className="mockup-name">Camarada! 🌙</div>
                  </div>
                </div>
                <div className="mockup-balance">
                  <div className="mockup-balance-label">Saldo geral</div>
                  <div className="mockup-balance-value">R$ 6.542,05</div>
                </div>
                <div className="mockup-items">
                  <div className="mockup-item">
                    <div className="mockup-item-left">
                      <div className="mockup-item-icon green">📥</div>
                      <div>
                        <div className="mockup-item-name">Salário</div>
                        <div className="mockup-item-date">01/04/2026</div>
                      </div>
                    </div>
                    <div className="mockup-item-details">
                      <div className="mockup-item-value positive">+R$ 7.425,99</div>
                      <div className="mockup-item-caption">Salário mínimo indicado pelo DIEESE (março/26)</div>
                    </div>
                  </div>
                  <div className="mockup-item">
                    <div className="mockup-item-left">
                      <div className="mockup-item-icon red">🛒</div>
                      <div>
                        <div className="mockup-item-name">Mercado</div>
                        <div className="mockup-item-date">03/04/2026</div>
                      </div>
                    </div>
                    <div className="mockup-item-details">
                      <div className="mockup-item-value negative">-R$ 883,94</div>
                      <div className="mockup-item-caption">Valor da cesta básica segundo o DIEESE (março/26)</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* MANIFESTO */}
      <section className="manifesto" id="manifesto">
        <div className="manifesto-container">
          <div className="section-tag">☭ Nosso Manifesto</div>
          <h2>Por que o MarxFlow existe?</h2>
          <p className="manifesto-text">
            Enquanto grandes corporações lucram bilhões vendendo seus dados financeiros e cobrando
            taxas abusivas, a classe trabalhadora segue sem acesso a ferramentas dignas para
            organizar seu suado dinheiro. O MarxFlow nasceu da convicção de que <strong>o controle
            financeiro é um direito, não um privilégio</strong>.
          </p>
          <p className="manifesto-text">
            Acreditamos que cada trabalhador e trabalhadora merece ter plena consciência de para
            onde vai cada centavo do fruto do seu trabalho. Sem propagandas, sem venda de dados,
            sem planos premium. O MarxFlow é do povo, para o povo.
          </p>
          <div className="manifesto-quote">
            <p>
              "Planejamento hoje é menos exploração amanhã. Conhecer suas finanças é o
              primeiro passo para a verdadeira liberdade da classe trabalhadora."
            </p>
            <cite>— O Camarada, conselheiro financeiro do MarxFlow</cite>
          </div>
        </div>
      </section>

      {/* FEATURES */}
      <section className="features" id="funcionalidades">
        <div className="features-container">
          <div className="features-header">
            <div className="section-tag">⚡ Funcionalidades</div>
            <h2>Ferramentas do povo, para o povo</h2>
            <p>Tudo que você precisa para controlar suas finanças com consciência e autonomia.</p>
          </div>
          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-icon red-bg">🏦</div>
              <h3>Gerenciamento de Contas</h3>
              <p>
                Cadastre todas suas contas bancárias em um só lugar. Tenha visão total do seu
                patrimônio sem depender dos apps dos bancos que te exploram.
              </p>
            </div>
            <div className="feature-card">
              <div className="feature-icon yellow-bg">💳</div>
              <h3>Controle de Cartões</h3>
              <p>
                Acompanhe faturas, limites e gastos de todos os seus cartões de crédito.
                Nunca mais seja pego de surpresa pela fatura — o poder é seu.
              </p>
            </div>
            <div className="feature-card">
              <div className="feature-icon green-bg">📊</div>
              <h3>Relatórios Inteligentes</h3>
              <p>
                Gráficos claros e relatórios detalhados que mostram para onde vai cada real.
                Conhecimento é poder — e agora ele está nas suas mãos.
              </p>
            </div>
            <div className="feature-card">
              <div className="feature-icon red-bg">📋</div>
              <h3>Contas a Pagar e Receber</h3>
              <p>
                Organize todas as suas contas com datas de vencimento. Nunca mais pague juros
                por esquecimento — juros enriquecem os banqueiros, não você.
              </p>
            </div>
            <div className="feature-card">
              <div className="feature-icon yellow-bg">🏷️</div>
              <h3>Categorias Personalizadas</h3>
              <p>
                Classifique seus gastos por categoria e descubra onde seu dinheiro vai.
                Despesas por categoria com gráficos visuais e porcentagens claras.
              </p>
            </div>
            <div className="feature-card">
              <div className="feature-icon green-bg">🔒</div>
              <h3>Privacidade Total</h3>
              <p>
                Seus dados são seus — não vendemos, não compartilhamos, não monetizamos.
                Diferente dos capitalistas, respeitamos sua privacidade.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CAMARADA */}
      <section className="camarada" id="camarada">
        <div className="camarada-container">
          <div className="camarada-visual">
            <div className="camarada-character">
              <div className="camarada-circle">
                <img src="/images/camarada/marxflow_calculadora.png" alt="O Camarada" className="camarada-image" />
              </div>
              {/* <div className="camarada-badge">O Camarada ☭</div> */}
            </div>
            <div className="camarada-tips-float">
              <p>"Não gaste mais do que ganha, camarada. Acumular dívidas só beneficia os banqueiros!"</p>
            </div>
          </div>

          <div className="camarada-content">
            <div className="section-tag">🎩 Personagem Exclusivo</div>
            <h2>Conheça <span>O Camarada</span></h2>
            <p className="camarada-description">
              Nosso conselheiro financeiro pessoal com consciência de classe. Ele aparece no app
              dando dicas financeiras com uma perspectiva que beneficia quem realmente trabalha.
              Nada de papo de coach financeiro milionário — aqui as dicas são para o povo real.
            </p>
            <div className="camarada-tips-list">
              <div className="camarada-tip">
                <span className="camarada-tip-icon">💡</span>
                <div>
                  <h4>Dicas com consciência</h4>
                  <p>Orientações financeiras que consideram a realidade do trabalhador brasileiro, não fantasias de renda passiva.</p>
                </div>
              </div>
              <div className="camarada-tip">
                <span className="camarada-tip-icon">📚</span>
                <div>
                  <h4>Educação financeira libertadora</h4>
                  <p>Entenda como o sistema financeiro funciona e proteja-se da exploração dos juros compostos contra você.</p>
                </div>
              </div>
              <div className="camarada-tip">
                <span className="camarada-tip-icon">✊</span>
                <div>
                  <h4>Frases motivacionais de luta</h4>
                  <p>Inspiração diária para manter a disciplina financeira como ferramenta de resistência e empoderamento.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* HOW IT WORKS */}
      <section className="how-it-works" id="como-funciona">
        <div className="how-container">
          <div className="how-header">
            <div className="section-tag">🚀 Simples assim</div>
            <h2>Como funciona?</h2>
            <p>Em três passos, você toma o controle das suas finanças.</p>
          </div>
          <div className="steps">
            <div className="step">
              <div className="step-number">1</div>
              <h3>Cadastre-se gratuitamente</h3>
              <p>Sem cadastro de cartão, sem período de teste. É grátis de verdade, como deveria ser.</p>
              <span className="step-arrow">→</span>
            </div>
            <div className="step">
              <div className="step-number">2</div>
              <h3>Cadastre suas contas e cartões</h3>
              <p>Adicione suas contas bancárias e cartões de crédito. Tudo organizado em um só lugar.</p>
              <span className="step-arrow">→</span>
            </div>
            <div className="step">
              <div className="step-number">3</div>
              <h3>Controle e liberte-se</h3>
              <p>Registre lançamentos, acompanhe relatórios e tome as rédeas da sua vida financeira.</p>
            </div>
          </div>
        </div>
      </section>

      {/* TESTIMONIALS */}
      <section className="testimonials" id="depoimentos">
        <div className="testimonials-container">
          <div className="testimonials-header">
            <div className="section-tag">❤️ Depoimentos</div>
            <h2>O que dizem os camaradas</h2>
          </div>
          <div className="testimonials-grid">
            <div className="testimonial-card">
              <div className="testimonial-stars">★★★★★</div>
              <p className="testimonial-text">
                "Finalmente um app que não tenta me vender investimento de coach. O Camarada me
                ajuda a economizar de verdade respeitando meu salário mínimo."
              </p>
              <div className="testimonial-author">
                <div className="testimonial-avatar">MF</div>
                <div>
                  <div className="testimonial-name">Maria Fernanda</div>
                  <div className="testimonial-role">Professora</div>
                </div>
              </div>
            </div>
            <div className="testimonial-card">
              <div className="testimonial-stars">★★★★★</div>
              <p className="testimonial-text">
                "Uso o MarxFlow há 6 meses e já consegui quitar duas dívidas. O controle de
                cartões é sensacional — agora eu sei pra onde vai cada centavo."
              </p>
              <div className="testimonial-author">
                <div className="testimonial-avatar">JS</div>
                <div>
                  <div className="testimonial-name">João Santos</div>
                  <div className="testimonial-role">Metalúrgico</div>
                </div>
              </div>
            </div>
            <div className="testimonial-card">
              <div className="testimonial-stars">★★★★★</div>
              <p className="testimonial-text">
                "O melhor app de finanças que já usei. Sem propaganda, sem venda de dados, sem
                plano premium. É do povo pro povo mesmo. Recomendo pra toda minha categoria!"
              </p>
              <div className="testimonial-author">
                <div className="testimonial-avatar">AC</div>
                <div>
                  <div className="testimonial-name">Ana Carolina</div>
                  <div className="testimonial-role">Enfermeira</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="cta" id="baixar">
        <div className="cta-container">
          <div className="cta-box">
            <h2>Junte-se à <span>revolução financeira</span></h2>
            <p className="cta-tagline">O fluxo do capital sob controle.</p>
            <p>
              Mais de 5 trabalhadores já tomaram o controle das suas finanças.
              Cadastre-se agora e faça parte do movimento!
            </p>
            <a href="#cadastrar" className="btn-primary-hero">
              ⬇ Cadastrar MarxFlow Grátis
            </a>
            <div className="cta-price">
              <span>R$ 0,00</span>
              <p>Gratuito para sempre — sem pegadinhas capitalistas</p>
            </div>
          </div>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="footer">
        <div className="footer-container">
          <div className="footer-top">
            <div className="footer-brand">
              <span className="navbar-logo">☭</span>
              <span className="navbar-title">MarxFlow</span>
              <p className="footer-tagline">O fluxo do capital sob controle.</p>
              <p>
                O aplicativo financeiro gratuito que coloca o controle do seu dinheiro nas
                mãos de quem realmente trabalha.
              </p>
            </div>
            <div className="footer-column">
              <h4>Produto</h4>
              <ul>
                <li><a href="#funcionalidades">Funcionalidades</a></li>
                <li><a href="#como-funciona">Como Funciona</a></li>
                <li><a href="#depoimentos">Depoimentos</a></li>
                <li><a href="#baixar">Download</a></li>
              </ul>
            </div>
            <div className="footer-column">
              <h4>Institucional</h4>
              <ul>
                <li><a href="#manifesto">Manifesto</a></li>
                <li><a href="#camarada">O Camarada</a></li>
                <li><a href="#baixar">Sobre Nós</a></li>
                <li><a href="#baixar">Contato</a></li>
              </ul>
            </div>
            <div className="footer-column">
              <h4>Legal</h4>
              <ul>
                <li><a href="#baixar">Privacidade</a></li>
                <li><a href="#baixar">Termos de Uso</a></li>
                <li><a href="#baixar">LGPD</a></li>
              </ul>
            </div>
          </div>
          <div className="footer-bottom">
            <p>&copy; 2026 MarxFlow. Todos os direitos pertencem ao povo.</p>
            <p className="footer-slogan">"Trabalhadores de todas as finanças, uni-vos!"</p>
          </div>
        </div>
      </footer>
    </div>
  )
}

export default App